import moment from 'moment';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Card, Col, Row, Nav, NavItem, NavLink, TabPane, TabContent, Form, Button } from 'reactstrap';
import { getColorPalette } from '../../Base/Common/ReferenceDataFunctions';
import { DateRangePicker } from 'react-dates';
import Demographics from "./Demographics";
import Acquisition from './Acquisition';
import TechDashboard from './TechDashboard';
import Engagement from './Engagement';
import Campaigns from './Campaigns';
import VouchersStats from './VouchersStats';
import { getAPI } from '../../Base/API';

class WidgetStatistics extends Component {
    static displayName = WidgetStatistics.name;

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            error: [],
            block: false,
            activeTab: 'Demographics',
            startDate: moment().subtract(7, 'days'),
            endDate: moment(),
            search: false,
            colorPalette: getColorPalette(),
            menus: [
                { value: 'Demographics', label: <FormattedMessage id="WidgetStatistics.Demographics" />, icon: 'fa-solid fa-globe mr-2' },
                { value: 'Acquisition', label: <FormattedMessage id="WidgetStatistics.Acquisition" />, icon: 'fa-solid fa-chart-column mr-2' },
                { value: 'Engagement', label: <FormattedMessage id="WidgetStatistics.Engagement" />, icon: 'fa-regular fa-hand-pointer mr-2' },
                { value: 'Tech', label: <FormattedMessage id="WidgetStatistics.Tech" />, icon: 'fa-solid fa-mobile-alt mr-2' },
                { value: 'Campaigns', label: <FormattedMessage id="WidgetStatistics.Campaigns" />, icon: 'fa-solid fa-link mr-2' },
                { value: 'Vouchers', label: <FormattedMessage id="WidgetStatistics.Vouchers" />, icon: 'fa-solid fa-gift mr-2' }
            ]
        }
    }

    componentDidMount() {
        this.setDatesArray();
        this.getVoucherTypes();
    }

    setDatesArray = () => {
        const { startDate, endDate } = this.state;

        const dates = new Array(moment(endDate.format("YYYY-MM-DD")).diff(moment(startDate.format("YYYY-MM-DD")), 'days')).fill(undefined)
            .reduce((acc, cur) => {
                acc.push(moment(startDate).add(acc.length, 'days').format("YYYY-MM-DD"));

                return acc;
            }, [moment(startDate).format("YYYY-MM-DD")])


        this.setState({ dates });
    }


    getVoucherTypes = () => {
        this.setState({ block: true });

        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    //handleNotification(data);
                    this.setState(({ block: false }));
                    return;
                }
                else {
                    var voucherTypes = data.response?.map(config => {
                        return { label: config.code, value: config.id }
                    });
                    this.setState({ block: false, voucherTypes });
                }
            }
        }, '/api/Voucher/V1/Config');
    }

    updateChartArray = (array, row, dimensionIndex, metricIndex, type) => {
        const index = array.findIndex(el => el[0] === row.dimensionValues[dimensionIndex].value);

        if (index !== -1) {
            array[index][1] += parseInt(row.metricValues[metricIndex].value);
        }
        else {
            const arr = type === 'BarChart' ? [row.dimensionValues[dimensionIndex].value, parseInt(row.metricValues[metricIndex].value), this.state.colorPalette[array.length - 1]] : [row.dimensionValues[dimensionIndex].value, parseInt(row.metricValues[metricIndex].value)]
            array.push(arr);
        }
        return array;
    }

    toggle = (id) => {
        this.setState({ activeTab: id })
    }

    toggleSearch = (e) => {
        if (e) e.preventDefault();

        this.setDatesArray();

        this.setState(prevState => ({
            search: !prevState.search
        }))
    }

    handleSelect = (combo, name) => {
        this.setState({
            [name]: combo ? combo.value : null
        });
    }

    valuesCard = (text, value) => {
        return <Card className="shadow border-0 h-100 justify-content-between" body>
            <Row className="row no-gutters align-items-center">
                <Col>
                    <div className="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                        {text}
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="text-right">
                    <h3 className="text-xs font-weight-bold text-secondary text-uppercase mb-1">
                        {value}
                    </h3>
                </Col>
            </Row>
        </Card>
    }

    handleDateRangeChange = (startDate, endDate) => {
        this.setState({
            startDate,
            endDate
        });

    }

    render() {
        const { activeTab, menus, colorPalette } = this.state;

        const userColors = [colorPalette[0]];

        const sourceColors = colorPalette;

        const revenueColors = colorPalette[0];

        return (
            <div className="container-fluid content-row p-0 py-2">
                <Row>
                    <Col className="col-2">
                        <Nav tabs vertical className="h-100 border-0">
                            <Card className="bg-white p-2 border-0 mb-3 shadow" body>
                                <h5 className='p-2'> Menu </h5>

                                {menus.map((menu, key) =>
                                    <NavItem className="pb-2" key={key}>
                                        <NavLink className={activeTab === menu.value ? 'text-primary  border-0 pointer border-left-primary' : 'bg-white border-0 pointer'} onClick={() => { this.toggle(menu.value); }} >
                                            <span><i className={menu.icon} /> {menu.label} </span>
                                        </NavLink>
                                    </NavItem>
                                )}
                            </Card>
                        </Nav>
                    </Col>
                    <Col className="col-10">
                        <Form onSubmit={this.toggleSearch}>
                            <Row className="mb-2">
                                <Col sm={3}>
                                    <DateRangePicker
                                        startDate={this.state.startDate ? moment(this.state.startDate) : null}
                                        startDateId="startDate"
                                        isOutsideRange={day => day > moment()}
                                        endDate={this.state.endDate ? moment(this.state.endDate) : null}
                                        endDateId="endDate"
                                        onDatesChange={({ startDate, endDate }) => this.handleDateRangeChange(startDate, endDate)}
                                        focusedInput={this.state.focusedInput}
                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                        small={true}
                                        required
                                        numberOfMonths={2}
                                        showDefaultInputIcon={true}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center">
                                    <Button className="btn btn-host btn-sm " type="submit">
                                        <i className="fa fa-magnifying-glass" />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                        <Row>
                            <Col>
                                <TabContent activeTab={activeTab} className="h-100">
                                    <TabPane tabId="Demographics" className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Demographics' ?
                                            <Demographics
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : null}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                            />
                                            : ''}
                                    </TabPane>

                                    <TabPane tabId='Acquisition' className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Acquisition' ?
                                            <Acquisition
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : this.state.startDate}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                valuesCard={this.valuesCard}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                                dates={this.state.dates}
                                            />
                                            : ''}
                                    </TabPane>

                                    <TabPane tabId="Engagement" className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Engagement' ?
                                            <Engagement
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : null}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                valuesCard={this.valuesCard}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                                dates={this.state.dates}
                                            />
                                            : ''}
                                    </TabPane>

                                    <TabPane tabId="Tech" className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Tech' ?
                                            <TechDashboard
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : this.state.startDate}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                            />
                                            : ''}
                                    </TabPane>

                                    <TabPane tabId="Campaigns" className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Campaigns' ?
                                            <Campaigns
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : this.state.startDate}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                            />
                                            : ''}
                                    </TabPane>

                                    <TabPane tabId="Vouchers" className="border-0 my-0 p-0 h-100">
                                        {activeTab === 'Vouchers' ?
                                            <VouchersStats
                                                startDate={this.state.startDate ? moment(this.state.startDate).locale(moment.locale()) : this.state.startDate}
                                                endDate={this.state.endDate ? moment(this.state.endDate).locale(moment.locale()) : this.state.endDate}
                                                updateChartArray={this.updateChartArray}
                                                toggleSearch={this.toggleSearch}
                                                search={this.state.search}
                                                sourceColors={sourceColors}
                                                userColors={userColors}
                                                revenueColors={revenueColors}
                                                dates={this.state.dates}
                                                voucherTypes={this.state.voucherTypes}
                                            />
                                            : ''}
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default injectIntl(WidgetStatistics);
